import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo } from 'react'

import { Item, Props as ItemProps } from './Item'

export interface Props {
  items: ItemProps[]
}

export const BannerCTA = memo(function BannerCTA({ items }: Props) {
  if (!items) {
    return null
  }

  return (
    <Container>
      <Wrapper row space="between" wrap>
        {items.slice(0, 2).map((item, index) => (
          <Item key={index} {...item} />
        ))}
      </Wrapper>
    </Container>
  )
})

const Container = styled.section`
  margin: 9.75rem auto 0;
  position: relative;
  &:before {
    content: '';
    width: 100%;
    height: 50%;
    background: ${({ theme }) => theme.colors.variants.neutralLight2};
    position: absolute;
    bottom: 0;
    left: 0;
  }

  @media (max-width: 1023px) {
    margin-top: 7.5rem;
  }
`

const Wrapper = styled(FlexBox)`
  max-width: 68.75rem;
  margin: auto;
  padding: 0 1.5rem;

  @media (max-width: 767px) {
    padding: 0;
  }
`
